"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleDynamicRelationship = exports.findAllPlansWithAnnualLimit = exports.findAllAvailableExcessOptions = void 0;
/**
 * This function finds all available excess options based on the selected
 * levelOfCover. Please refer to test file for the detailed structure of
 * input and return items.
 *
 * @param {Object} plans - Plans object to iterate.
 * @param {*} levelOfCover - selected levelOfCover
 */
var findAllAvailableExcessOptions = exports.findAllAvailableExcessOptions = function findAllAvailableExcessOptions(_ref) {
  var plans = _ref.plans,
    levelOfCover = _ref.levelOfCover;
  var availableExcessOptions = [];
  plans.forEach(function (plan) {
    plan.upmExcessOptions.forEach(function (excessOption) {
      if (excessOption.levelOfCover === parseInt(levelOfCover, 10) && !availableExcessOptions.includes(excessOption.excess)) {
        availableExcessOptions.push(excessOption.excess);
      }
    });
  });
  return availableExcessOptions;
};

/**
 * This function returns the list of available plans object that matches
 * the given annual limit amount.
 *
 * @param {*} AllPlans AllPlans object to iterate.
 * @param {*} annualLimit - annual limit to look for.
 */
var findAllPlansWithAnnualLimit = exports.findAllPlansWithAnnualLimit = function findAllPlansWithAnnualLimit(_ref2) {
  var AllPlans = _ref2.AllPlans,
    annualLimit = _ref2.annualLimit,
    levelOfCover = _ref2.levelOfCover;
  return Object.keys(AllPlans).filter(function (plan) {
    return AllPlans[plan].limits.annualLimit.amount === parseInt(annualLimit, 10) && AllPlans[plan].upmExcessOptions.some(function (excessOption) {
      return excessOption.levelOfCover === parseInt(levelOfCover, 10);
    });
  }).map(function (plan) {
    return AllPlans[plan];
  });
};

/**
 * Handles the dynamic relationship between selected annual limit, levelOfCover, and
 * excess options. This function fallbacks to the default excess value when the next
 * radio option (annualLimit, or levelOfCover) does not support currently selected
 * excess option. This function calls the selection handler to falls back to the
 * default value and uses defaultValueIndex field of the excess label definition.
 *
 * @param {Object} params - The parameters for the function.
 * @param {boolean} params.productsAreMerged - Indicates if products are merged.
 * @param {Array<Object>} params.dynamicRelationship - An array of dynamic relationship objects.
 * @param {Object} params.AllPlans - An associative array of all available plans.
 * @param {Object} params.selectedOptions - The currently selected options.
 * @param {string} params.productGroup - The product group associated with the options.
 * @param {Function} params.selectedOptionsHandler - A function to handle selected options and fallback.
 * @param {string} params.nextRadioValueType - The type of the next radio value.
 * @param {number} params.nextRadioValue - The next radio value to be processed.
 */
var handleDynamicRelationship = exports.handleDynamicRelationship = function handleDynamicRelationship(_ref3) {
  var productsAreMerged = _ref3.productsAreMerged,
    dynamicRelationship = _ref3.dynamicRelationship,
    AllPlans = _ref3.AllPlans,
    selectedOptions = _ref3.selectedOptions,
    productGroup = _ref3.productGroup,
    selectedOptionsHandler = _ref3.selectedOptionsHandler,
    nextRadioValueType = _ref3.nextRadioValueType,
    nextRadioValue = _ref3.nextRadioValue;
  if (!productsAreMerged) {
    return;
  }
  if (dynamicRelationship && dynamicRelationship.length <= 0) {
    return;
  }
  var matchingPlansForCurrentAnnualLimit = findAllPlansWithAnnualLimit({
    AllPlans: AllPlans,
    annualLimit: nextRadioValueType === 'annualLimit' ? nextRadioValue : selectedOptions.merged[productGroup].annualLimit,
    levelOfCover: nextRadioValueType === 'levelOfCover' ? nextRadioValue : selectedOptions.merged[productGroup].levelOfCover
  });
  var availableExcessOptions = findAllAvailableExcessOptions({
    plans: matchingPlansForCurrentAnnualLimit,
    levelOfCover: nextRadioValueType === 'annualLimit' ? selectedOptions.merged[productGroup].levelOfCover : nextRadioValue
  });
  var currentlySelectedAccess = parseInt(selectedOptions.merged[productGroup].excess, 10);
  var hasDynamicRelationshipWithExcess = dynamicRelationship && dynamicRelationship.find(function (relation) {
    return relation.excess !== undefined;
  });
  if (!availableExcessOptions.includes(currentlySelectedAccess) && hasDynamicRelationshipWithExcess) {
    var defaultValueIndex = hasDynamicRelationshipWithExcess.excess.defaultValueIndex;
    selectedOptionsHandler(availableExcessOptions[defaultValueIndex], 'excess');
  }
};